/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/camelcase */
import React = require('react')
import { Pair, IOWidget, Action, mkWidget, any } from 'widgets-for-react'
import { CustomBlockData, isCustomBlockData, renderCustomBlock } from './custom_blocks/types.mod'
import { ExtraImages } from '../utils/extra_images.mod'
import { CMSState } from '../../cms/blocks/types.gen'
import { getMockedBlockRenderer, BlocksRenderer, renderBlock } from '../../cms/blocks/block_to_widget.gen'
import { Block } from '../../drupal/types_and_parser/standard_blocks.gen'
import { TemplateState } from '../../cms/page/types.gen'
import { PublicSite_CustomPageData } from '../application.mod'
import { PublicSiteState } from '../../../public_site.main.mod'
import { CustomBlock } from '../../drupal/types_and_parser/custom_blocks.mod'

export const blocks_renderer = <
  CustomBlockData extends { kind: CustomBlockData['kind'] },
  extra_images,
  customPageData
>() => ({
  ...getMockedBlockRenderer<CustomBlockData, extra_images, customPageData>()
})

export function pageDisplay_AUX(
  blocks: (Block | CustomBlock)[],
  blocks_renderer: BlocksRenderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>,
  public_state: PublicSiteState
): IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
> {
  return (s) =>
    any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([
      ...s.blocks
        .map((b, index) =>
          isCustomBlockData(b)
            ? renderCustomBlock(
                b,
                public_state,
                `key-${index}`
              )(s).map<
                Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
              >((a) => (s1) => {
                const res = a(s1)
                return { ...s1, images: res.images, blocks: res.blocks, custom_page_data: res.custom_page_data }
              })
            : renderBlock(
                b,
                blocks_renderer,
                `key-${index}`
              )(s).map<
                Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
              >((a) => (s1) => {
                const res = a(s1)
                return { ...s1, images: res.images, blocks: res.blocks }
              })
        )
        .toArray()
    ])
}
export const pageDisplay = (
  blocks_renderer: BlocksRenderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>
): ((
  b: (Block | CustomBlock)[],
  public_state: PublicSiteState
) => IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
>) => (b, public_state) => pageDisplay_AUX(b, blocks_renderer, public_state)
